export enum ShipmentType {
  Return = 'return',
}
